import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Seven Solutions</h3>
            <p>Empowering SMEs with AI-driven automation and cloud solutions</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services/ai-workflow-automation">AI Workflow Automation</Link></li>
              <li><Link to="/services/cloud-devops">Cloud & DevOps Setup</Link></li>
              <li><Link to="/services/ai-strategy">AI Strategy Consulting</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Serving</h4>
            <p>United States | United Kingdom</p>
            <p>Middle East | INDIA</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Seven Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
